import React from 'react';
import { Link } from 'react-router-dom';
import { EMAIL, profiles } from '../data/links';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {year} Colin Stebelski</p>
        <div className="footer-links">
          <Link to="/contact">Contact</Link>
          {profiles.map((p) => (
            <a key={p.label} href={p.url} target="_blank" rel="noopener noreferrer">{p.label}</a>
          ))}
          <a href={`mailto:${EMAIL}`}>Email</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
